var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 13.375H2.375C1.61417 13.375 1 12.7608 1 12V2.375C1 1.61417 1.61417 1 2.375 1H16.125C16.8858 1 17.5 1.61417 17.5 2.375V6.5M1 5.125H17.5M8.33333 9.8C10.4142 10.2721 12.9442 9.55708 15.6667 8.33333C18.3892 9.55708 20.9192 10.2721 23 9.8V14.0533C23 18.4029 19.9292 22.1475 15.6667 23C11.4042 22.1475 8.33333 18.4029 8.33333 14.0533V9.8Z",
    stroke: "#57486D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSecure);
export default __webpack_public_path__ + "static/media/card-secure.277faecb8658df877168ae37344e37a7.svg";
export { ForwardRef as ReactComponent };